import { errorMsg } from '../utils/errorMsg';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Paper,
  Grid,
  MenuItem,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import api from '../axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import StartForm from '../components/StartForm';

export default function FormularioVisitante() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  
  const [form, setForm] = useState({
    nome: '',
    sexo: '',
    telefone: '',
    email: '',
    whatsapp: '',
    data_nascimento: '',
    rua: '',
    bairro: '',
    cep: '',
    cidade: '',
    estado: '',
    quer_ser_membro: false,
    deseja_oracao: false,
    quer_conhecer_jesus: false,
    origem_cadastro: 'formulario_online'
  });

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setForm({ 
      ...form, 
      [name]: e.target.type === 'checkbox' ? checked : value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/visitantes/', form);
      setSuccess(true);
      setForm({
        nome: '',
        sexo: '',
        telefone: '',
        email: '',
        whatsapp: '',
        data_nascimento: '',
        rua: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        quer_ser_membro: false,
        deseja_oracao: false,
        quer_conhecer_jesus: false,
        origem_cadastro: 'formulario_online'
      });
      
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (err) {
      setError(errorMsg(err) || 'Erro ao enviar formulário. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" color="success.main" gutterBottom>
            ✅ Formulário enviado com sucesso!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            Obrigado por sua visita! Em breve entraremos em contato.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Você será redirecionado para a página inicial...
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <>
      <Header />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #009758 0%, #00b468 100%)',
          py: { xs: 2, md: 4 }
        }}
      >
      <Container maxWidth="md">
        <StartForm
          title="Formulário de Visitante"
          description="Preencha os dados abaixo para que possamos entrar em contato."
          onBack={() => navigate('/')}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <TextField
                  required
                  fullWidth
                  label="Nome Completo"
                  name="nome"
                  value={form.nome}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  required
                  fullWidth
                  select
                  label="Sexo"
                  name="sexo"
                  value={form.sexo}
                  onChange={handleChange}
                >
                  <MenuItem value="masculino">Masculino</MenuItem>
                  <MenuItem value="feminino">Feminino</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Telefone"
                  name="telefone"
                  value={form.telefone}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="WhatsApp"
                  name="whatsapp"
                  value={form.whatsapp}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="E-mail"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Data de Nascimento"
                  name="data_nascimento"
                  type="date"
                  value={form.data_nascimento}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Rua/Endereço"
                  name="rua"
                  value={form.rua}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Bairro"
                  name="bairro"
                  value={form.bairro}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="CEP"
                  name="cep"
                  value={form.cep}
                  onChange={handleChange}
                  placeholder="00000-000"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Cidade"
                  name="cidade"
                  value={form.cidade}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Estado"
                  name="estado"
                  value={form.estado}
                  onChange={handleChange}
                  placeholder="PE"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                  Motivos da Visita:
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.quer_ser_membro}
                      onChange={handleChange}
                      name="quer_ser_membro"
                    />
                  }
                  label="Quer ser membro"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.deseja_oracao}
                      onChange={handleChange}
                      name="deseja_oracao"
                    />
                  }
                  label="Deseja oração"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.quer_conhecer_jesus}
                      onChange={handleChange}
                      name="quer_conhecer_jesus"
                    />
                  }
                  label="Quer conhecer Jesus"
                />
              </Grid>
            </Grid>

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mt: 2 }}>
                Formulário enviado com sucesso! Redirecionando...
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 3 }}
              aria-label="Enviar formulário visitante"
            >
              {loading ? 'Enviando...' : 'Enviar Formulário'}
            </Button>
          </Box>
        </StartForm>
      </Container>
      <Footer />
    </Box>
    </>
  );
}
